import moment from 'moment-timezone';

export class ContractPerformanceBreakdownDataPoints {
	public x: Date;
	public y: number;
	public dataType: string;
	public markerType: string;

	constructor(contractPerformanceBreakdownDataPoint?: ContractPerformanceBreakdownDataPoints) {
		Object.assign(this, contractPerformanceBreakdownDataPoint);

		this.x = this.x ? new Date(moment(this.x).format('MMM DD, YYYY hh:mm:ss a')) : this.x;
	}
}
